import { render, staticRenderFns } from "./CustomFieldsMapping.vue?vue&type=template&id=1318ae89&scoped=true&"
import script from "./CustomFieldsMapping.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldsMapping.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFieldsMapping.vue?vue&type=style&index=0&id=1318ae89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318ae89",
  null
  
)

export default component.exports